import { render, staticRenderFns } from "./candidateTable.vue?vue&type=template&id=4f1369c8"
import script from "./candidateTable.vue?vue&type=script&lang=js"
export * from "./candidateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports